import { Injectable } from '@angular/core';
import { Rotas } from '@core/enums/routes';
import { HttpClientProtectedService } from '@core/services/auth/http-client-protected.service';
import { map, Observable } from 'rxjs';
import { moment } from '@lib/moment-wrap';
import {
	ExecucaoMeteograma,
	ExecucaoMeteogramaDTO,
} from '@home/submodulos/previsao-numerica-tempo/interfaces/meteograma';

export interface ModeloPorVariavelDTO {
	deslocamentoTempo: number;
	caminhoImagem: string;
}

export interface ModeloNumericoResultadoDTO {
	tempoBase: moment.Moment;
	quantidadeHorasPrevisao: number;
	listaImagens: ModeloPorVariavelDTO[];
}

interface ModeloNumericoResultadoResponse {
	tempoBase: string;
	quantidadeHorasPrevisao: number;
	listaImagens: ModeloPorVariavelDTO[];
}

@Injectable({
	providedIn: 'root',
})
export class PrevisaoTempoService {
	constructor(private http: HttpClientProtectedService) {}

	buscarModeloNumerico(
		execucao: string,
		grade: string,
		variavelModelo: string,
		resolucaoEspacial: number
	): Observable<ModeloNumericoResultadoDTO> {
		return this.http
			.get<ModeloNumericoResultadoResponse>(
				Rotas.MODELONUMERICO + '/resultado',
				{
					execucao,
					resolucaoEspacial,
					grade,
					variavelModelo,
				}
			)
			.pipe(
				map(({ tempoBase, ...props }) => ({
					tempoBase: moment.utc(tempoBase),
					...props,
				}))
			);
	}

	listarExecucoes(): Observable<ExecucaoMeteograma[]> {
		return this.http.get<ExecucaoMeteogramaDTO[]>(
			Rotas.MODELONUMERICO + '/execucoes'
		);
	}
}
